import React from 'react';
import Popover from '@mui/material/Popover';
import ModalSubmitForm from '../../../components/sarang-modals/modal-submit-form/modal-submit-form';
import ModalConfirm from '../../../components/sarang-modals/modal-confirm/modal-confirm';
import ModalAlert from '../../../components/sarang-modals/modal-alert/modal-alert';
import ModalBulkCreateUserResult from '../../../components/sarang-modals/modal-bulk-create-user-result/modal-bulk-create-user-result';
import ModalAssignPermission from '../../../components/sarang-modals/modal-assign-permission/modal-assign-permission';
import FormAddEditHerdsman from './form-add-edit-herdsman';
import FormSendMessage from './form-send-message';
import DepartmentHelper from '../../list-department/helper/department-helper';

const HerdsmanModals = (props) => {
    const {
        anchorEl, handleCusClose, customer, open,
        isOpenSendMessage, selectedItem, isOpenAddEditDialog,
        closeAddEditDialog, closeSendMessageDialog,
        group, department, herdsman, zion, zionArea, district,
        position, wMTeam, branch, handleSubmitAddEditHerdsman,
        handleSubmitSendMessage, isOpenDeleteDialog, isOpenActiveDialog,
        isOpenUpgradeDialog, isOpenDowngradeDialog, isOpenDeactiveDialog,
        isOpenCreateAccountDialog, closeConfirmDialog, handleConfirm,
        isOpenAlertUserName, user, closeAlertDialog, handleCopy,
        isOpenBulkCreateResult, setOpenBulkCreateResult, bulkCreateResult,
        isOpenBulkCreateConfirm, setOpenBulkCreateConfirm, onConfirmBulkCreate,
        isOpenAssignPermission, closeAssignPermissionDialog, getListHerdsmanManagement,
        page, rowsPerPage, orderBy, order, searchData, showLoading
    } = props;

    return (
        <>
            <Popover
                id='buoc1'
                open={open}
                anchorEl={anchorEl}
                onClose={handleCusClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                {customer && customer.length > 0 && customer.filter(x => x.status >= 50).length > 0 && (
                    <table className="table table-bordered table-hover dataTable" id="datatables">
                        <thead>
                            <tr>
                                <th><b>STT</b></th>
                                <th><b>Họ và tên</b></th>
                                <th><b>Giới tính</b></th>
                                <th><b>Độ tuổi</b></th>
                                <th><b>Hạng mục</b></th>
                            </tr>
                        </thead>
                        <tbody>
                            {customer.filter(x => x.status >= 50).map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    <td>{rowIndex + 1}</td>
                                    <td>{row.fullName}</td>
                                    <td>{row.gender == 0 ? "Nữ" : "Nam"}</td>
                                    <td>{row.departmentName}</td>
                                    <td>{row.statusName}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </Popover>

            <ModalSubmitForm
                title={isOpenSendMessage ? "Nhắn tin cho ace" : (!selectedItem ? "Thêm mới ace" : "Chỉnh sửa thông tin ace")}
                open={isOpenAddEditDialog || isOpenSendMessage}
                onClose={!isOpenSendMessage ? closeAddEditDialog : closeSendMessageDialog}
            >
                {!isOpenSendMessage ? (
                    <FormAddEditHerdsman
                        group={group}
                        department={department}
                        herdsman={herdsman}
                        zion={zion}
                        zionArea={zionArea}
                        district={district}
                        position={position}
                        wMTeam={wMTeam}
                        branch={branch}
                        updateItem={selectedItem}
                        onSubmitAddEdit={handleSubmitAddEditHerdsman}
                    />
                ) : (
                    <FormSendMessage
                        herdsman={selectedItem}
                        onSubmitSendMessage={handleSubmitSendMessage}
                    />
                )}
            </ModalSubmitForm>

            <ModalConfirm
                title={"Xác nhận"}
                prompt={
                    isOpenDeleteDialog ? "Ae/Ce có chắc chắn muốn xóa bản ghi này không?" :
                    isOpenActiveDialog ? "Ae/Ce có chắc chắn muốn mở khóa bản ghi này không?" :
                    isOpenUpgradeDialog ? "Ae/Ce có chắc chắn muốn nâng cấp AE/CE này lên SWAT không?" :
                    isOpenDowngradeDialog ? "Khi hạ cấp xuống Thánh đồ, toàn bộ dữ liệu ta-lâng sẽ bị xóa và không khôi phục được. \n\rAe/Ce có chắc chắn muốn hạ cấp AE/CE này xuống Thánh Đồ không?" :
                    isOpenDeactiveDialog ? "Ae/Ce có chắc chắn muốn khóa bản ghi này không?" :
                    isOpenCreateAccountDialog ? "Ae/Ce có chắc chắn muốn tạo tài khoản cho SWAT này không?" : ""
                }
                open={isOpenDeleteDialog || isOpenActiveDialog || isOpenDeactiveDialog || isOpenCreateAccountDialog || isOpenUpgradeDialog || isOpenDowngradeDialog}
                onClose={closeConfirmDialog}
                onConfirm={handleConfirm}
            />

            <ModalAlert
                title={"Thông báo"}
                prompt={isOpenAlertUserName ? `Ae/Ce vui lòng gửi tài khoản cho Ace vừa tạo là {${user?.user}/${user?.pwd}}` : ""}
                open={isOpenAlertUserName}
                onClose={closeAlertDialog}
                onCopy={handleCopy}
            />

            <ModalBulkCreateUserResult
                open={isOpenBulkCreateResult}
                onClose={() => setOpenBulkCreateResult(false)}
                result={bulkCreateResult}
            />

            <ModalConfirm
                id="modalBulkConfirm"
                open={isOpenBulkCreateConfirm}
                onClose={() => setOpenBulkCreateConfirm(false)}
                onConfirm={onConfirmBulkCreate}
                title="Xác nhận tạo tài khoản"
                prompt="Bạn có chắc chắn muốn tạo tài khoản đăng nhập cho những herdsman này?"
            />

            <ModalAssignPermission
                open={isOpenAssignPermission}
                onClose={closeAssignPermissionDialog}
                herdsman={selectedItem}
                onSuccess={() => {
                    closeAssignPermissionDialog();
                    getListHerdsmanManagement(page + 1, rowsPerPage, orderBy + ' ' + order, searchData);
                }}
                showLoading={showLoading}
            />
        </>
    );
};

export default HerdsmanModals;
